module.exports = __webpack_public_path__ + "img/warning.598f8efd.svg";